module.exports = __webpack_public_path__ + "static/img/why-1.c5efb1cd.jpg";